import React from 'react';
const CalendarFilterSVG = ({ color = 'black', className }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.7015 1.36426V3.44915C15.7015 4.50453 14.8264 5.37965 13.771 5.37965C12.7156 5.37965 11.8405 4.50453 11.8405 3.44915V1.36426H7.85074V3.44915C7.85074 4.50453 6.97562 5.37965 5.92024 5.37965C4.86485 5.37965 3.98974 4.50453 3.98974 3.44915V1.36426C1.7761 1.44146 0 3.24323 0 5.48274V15.6758C0 18.0438 1.85328 20 4.11849 20H15.5728C17.8379 20 19.6913 18.0695 19.6913 15.6758V5.48274C19.7169 3.24341 17.9152 1.44148 15.7015 1.36426H15.7015ZM18.1724 15.6757C18.1724 17.1943 17.0142 18.4556 15.5984 18.4556L4.11839 18.4554C2.70265 18.4554 1.5444 17.2199 1.5444 15.6755V7.31001H18.1467V15.6755L18.1724 15.6757Z"
        fill={color}
      />
      <path
        d="M5.0451 3.44929C5.0451 3.9384 5.45699 4.35028 5.9461 4.35028C6.4352 4.35028 6.84709 3.9384 6.84709 3.44929V0.900991C6.84709 0.411885 6.43521 0 5.9461 0C5.45699 0 5.0451 0.411881 5.0451 0.900991V3.44929Z"
        fill={color}
      />
      <path
        d="M12.8958 3.44929C12.8958 3.9384 13.3077 4.35028 13.7968 4.35028C14.2859 4.35028 14.6978 3.9384 14.6978 3.44929V0.900991C14.6978 0.411885 14.2859 0 13.7968 0C13.3077 0 12.8958 0.411881 12.8958 0.900991V3.44929Z"
        fill={color}
      />
    </svg>
  );
};

export default CalendarFilterSVG;
